/* import __COLOCATED_TEMPLATE__ from './no-actions.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();